export enum LanguageToggleTarget {
  Subtitles,
  Audio,
}
